export const locale = {
    lang: 'zh1',
    data: {
      'FILEMANAGER': {
        'TITULO': '文件管理器',
        'SUBTI': '上載公司相關文件',
        'GPTW': {
          'TITULO': '單擊公司名稱以顯示上傳的文件列表',
          'NUMFILES': '上傳的文件數：'
        },
        'CT_NAME':'發生嚴重創傷事件的合作者',
        'LABEL01':'  工作中心',
        'CARGA': {
          'TITULO': '單擊此處上傳文件或將其拖放到此處',
          'CARGANDOTIT': '上載中',
          'CARGANTOTXT': '該文件正在發送到數據庫。 請稍等。'
        },
        'MENU': {
          'BOTON': '新',
          'ARCHIVO': '文件',
          'CARPETA': '夾',
          'EXCELTI': '下載 Excel TI'
        },
        'LISTA': {
          'TITULOS': {
            'NOMBRE': '名稱',
            'EXTEN': '延期',
            'FECHA': '上傳日期',
            'ACCIONES': '動作',
            'TAMANIO': '尺寸'
          },
           // Temporales
          'TITULOSENC':{
            'NOMBRE': '合作者名稱：',
            'ARCH':'文檔名稱',
            'DATE': '更新日期',
            'EXTEN': '工作中心名稱：',
            'ACT': '動作',
            'BT':'家'
          },
          'TOOLTIP': {
            'DESCARGA': '下載此文件',
            'DELETE': '刪除這個檔案',
            'OPENFOLDER': '單擊此處打開此文件夾',
            'VACIO': '這個文件夾是空的'
          }
        },
        'MENSAJES': {
          'CARGAOK': '文件已成功存儲',
          'CARGAREP': '文件未存儲。 具有相同名稱的文件已存在',
          'DELETERLY': '您確認刪除此文件嗎？',
          'DELETEOK': '該文件已正確刪除',
          'CREATEFOLDER': '輸入新文件夾的名稱',
          'FOLDEROK': '該文件夾已成功創建。',
          'archivo_save_4': '無法創建該文件夾。 具有相同名稱的文件夾已存在',
          'DELETEFOLDERRLY': '您確認刪除此文件夾嗎？\n\n警告：此文件夾的內容也將被刪除',
          'DELETEFOLDEROK': '該文件夾及其內容已成功刪除',
          'INVALID_CHARS': '文件夾名稱只能包含從字母 A 到 Z 的字符和數字',
          'BOTONES': {
            'SI': '是',
            'NO': '沒有',
            'ACEPTAR': '接受',
            'CREAR': '創建',
            'CANCELAR': '取消'
          }
        },
        'CARPETASDEFAULT':{
          'Información TI': 'TI信息',
          'Información CA': 'CA信息',
          'Información General': '一般信息',
          'Comunicación NOM035': 'NOM035通訊',
          'Plantilla listado colaboradores': '協作者列表模板',
          'Campaña de Comunicación 2020': '年宣傳運動',
          // 'Culture Audit': '文化審核',
          'Guía de certificación': '認證指南',
          'Listado de colaboradores': '合作者名單',
          'Plantillas': 'Templates',
          'Templates con TI': 'Templates with IT',
          'Templates Página' : 'Page templates',
          'Certificar' : 'Certify',
          'Focus Area' : 'Focus Area',
          'Medir' : 'Measurement',
          'Pulsecheck' : 'Pulse Check',
          'Row Data': 'Row Data',
          'Reports': '報告書',

          'Campana de Comunicacion': '傳播活動',
          'Culture Audit': '文化審核™',
          'Great Book': '好書',
          'Cuestionarios': '問卷調查',
          'Pulse Check': '按檢查',
          'Base de datos': '數據庫',
          'Practicas For All': '所有人的實習',
          'Reporte de Resultados': '結果報告',
          'Validacion': '驗證',
        }
      }
    }
};
